import React from "react";
import { Container } from "./styled/aria-message";
function AriaMessage(_a) {
    var _b = _a.live, live = _b === void 0 ? "off" : _b, children = _a.children;
    return React.createElement(Container, { "aria-live": live }, children);
}
export default AriaMessage;
